/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-18 17:39:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-11-07 14:18:24
 */
import request from '@/utils/request'

export function phonelogin (data) {
  return request({
    url: '/phonelogin',
    method: 'post',
    data
  })
}

export function login (data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function getInfo (token) {
  return request({
    url: '/admin/userinfo',
    method: 'get',
    params: { token }
  })
}

export function logout () {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function fetchList (query) {
  //   return request({
  //     url: '/user/list',
  //     method: 'get',
  //     params: query
  //   })
  return request({
    url: '/admin/list',
    method: 'get',
    params: query
  })
}

export function fetchDetail (query) {
  return request({
    url: '/admin/detail',
    method: 'get',
    params: query
  })
}

export function create (data) {
  return request({
    url: '/admin/create',
    method: 'post',
    data
  })
}

export function update (data) {
  //   return request({
  //     url: '/user/update',
  //     method: 'post',
  //     data
  //   })
  return request({
    url: '/admin/editinfo',
    method: 'post',
    data
  })
}

export function del (data) {
  //   return request({
  //     url: '/user/del',
  //     method: 'post',
  //     data
  //   })
  return request({
    url: '/admin/remove',
    method: 'post',
    data
  })
}

export function role (data) {
  return request({
    url: '/user/role',
    method: 'post',
    data
  })
}

export function password (data) {
  //   return request({
  //     url: '/user/password',
  //     method: 'post',
  //     data
  //   })
  return request({
    url: '/admin/editpassword',
    method: 'post',
    data
  })
}
// 更新用户角色
export function updrole (data) {
  return request({
    url: '/admin/updrole',
    method: 'post',
    data
  })
}
// 查看密码是否过期
export function ispwdtimeout (query) {
  return request({
    url: '/admin/ispwdtimeout',
    method: 'get',
    params: query
  })
}
